import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import TrackingCustomer from './components/TrackingCustomer.jsx';

const homesNews = (props,{ t }) => (
  <Container>
    <TrackingCustomer {...props} />
  </Container>
);

homesNews.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(TrackingCustomer);
